module.exports = __webpack_public_path__ + "static/img/know_how_1.efce0ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/know_how_1.jpg
// module id = mjo3
// module chunks = 0